
import React, {Component} from 'react';
import ReportGeneralTable from './ReportGeneralTable'
import ReportStore from '../../stores/ReportStore'
import FontAwesome from 'react-fontawesome'
import { Popover, OverlayTrigger } from 'react-bootstrap'
import QuotationDoc from '../qo/QuotationDoc'
import {Checkbox} from 'react-icheck'
import IframeModal from '../../component/element/IframeModal'
import JSWorkDocViewModal from 'view/workdoc/JSWorkdocViewModal';

const cHeaderTitles = [
  {title:'',width:'50px',checkAll:true},
  {title:'วันที่ออก',width:'100px'},
  {title:'เลขที่ใบเสนอราคา',width:'120px'},
  {title:'ใบงานเลขที่',width:'220px'},
  {title:'ทะเบียนรถ',width:'150px'},
  {title:'ยี่ห้อ',width:'150px'},
  {title:'รุ่น',width:'150px'},
  {title:'กม.',width:'80px'},
  {title:'ชื่อลูกค้า',width:'200px'},
  {title:'มูลค่า(บาท)',width:'100px'},
  {title:'อนุมัติ(บาท)',width:'100px'},   
  {title:'สถานะ',width:'100px'},       
]
const cHeaderTitlesCompany = [
  {title:'',width:'50px',checkAll:true},
  {title:'วันที่ออก',width:'100px'},
  {title:'ออกโดย',width:'100px'},
  {title:'เลขที่ใบเสนอราคา',width:'120px'},
  {title:'ใบงานเลขที่',width:'220px'},
  {title:'ทะเบียนรถ',width:'150px'},
  {title:'ยี่ห้อ',width:'150px'},
  {title:'รุ่น',width:'150px'},
  {title:'กม.',width:'80px'},
  {title:'ชื่อลูกค้า',width:'200px'},
  {title:'มูลค่า(บาท)',width:'100px'},  
  {title:'อนุมัติ(บาท)',width:'100px'},   
  {title:'สถานะ',width:'100px'},       
]
class ReportQuotationPage extends Component {

  
  constructor(...args){
    super(...args)
    this.state = {showTable:true,headerTitles:cHeaderTitles,companylist:[],data:[],isCheckAll:false,check:[],showSelectMenu:false}
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  showTable(){
    this.setState({showTable:true})
    // this.refs.qoTable.refreshTable()   
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  onRowSelect(item){
    
    this.setState({showTable:false,qoNo:item.doc_no,billNo:item.bill_no},()=>{
      if(this.props.onDocShow!==undefined){      
        this.props.onDocShow(item.doc_no)
      }else{
        //this.props.history.push({pathname:'/quotation/doc'})
        // this.refs.qoTable.loadData(item.work_no)   
        window.show_quotation_doc(item.doc_no,()=>{
          this.setState({showTable:true})
          console.log("close handler");
        });        
      }
    })
    
    //alert('qo'+item.doc_no)
  }


  // onDocNew(){
  //   this.setState({showTable:false})
  //   let that = this
  //   this.refs.soDoc.loadNewDoc(function(item){
  //     if(that.props.onDocShow!==undefined){
  //       that.props.onDocShow(item.sale_order_no)
  //     }
  //   })    
  // }

  onDocClose(){
    this.showTable() 
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    let {headerTitles} = this.state
    ReportStore.loadQuotationList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result)
      if (result.companylist.length>1) {
        headerTitles = cHeaderTitlesCompany
      } 
      this.setState({companylist:result.companylist,headerTitles:headerTitles})
      callback(result)
    })
  }

  loadDataRange(start,end,searchBy,query,activePage,itemPerPage,callback){
    let {headerTitles} = this.state
    ReportStore.loadQuotationListRange(start,end,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result)
      if (result.companylist.length>1) {
        headerTitles = cHeaderTitlesCompany
      } 
      this.setState({companylist:result.companylist,headerTitles:headerTitles})
      callback(result)
    })
  }

  processData(result){
    result.data = result.data.map((item,index)=>{
      item = Object.assign({check:false},item)
      return item
    })
    this.setState({data:result.data,isCheckAll:false,showSelectMenu:false,check:new Array(result.data.length).fill(false)}) 
  }

  // renderStatus(status,row){
  //   status = status*1
  //   let result  = (<span></span>)
  //   if(status===1){
  //     result =  (<span className='label label-success'>ชำระเงินแล้ว</span>)
  //   }else    if(status===2){
  //     result =  (<span className='label label-primary'>ขายเครดิต</span>)
  //   }else{
  //     result = (<span></span>)
  //   }
  //   if(row.recordid!==undefined && row.recordid*1>0){
  //     result = (<div>{result} {this.renderStockStatus(row.recordid)}</div>)
  //   }
  //   return result
  // }

  renderStatus(status,row){
    let result = (<span></span>)

    if (row.work_status==='0') {
      result = (<span className="label label-default" data-value="0">เริ่มต้น</span>)
    }else if (row.work_status==='1') {
      result = (<span className="label label-warning" data-value="1">อยู่ระหว่างซ่อม</span>)
    } else if (row.work_status==='2') {
      result = (<span className="label label-primary" data-value="2">รอส่งมอบรถ</span>)
    } else if (row.work_status==='3') {
      result = (<span className="label label-success" data-value="3">ปิดจบงาน</span>)
    } else if (row.work_status==='5') {
      result = (<span className="label label-purple" data-value="5">ตั้งเบิก</span>)
    } else{
      result = (<span></span>)
    }

    return result
  }

  // renderStockStatus(status){ 
  //   status = status*1
  //   if(status>0){
  //     return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
  //   }else{
  //     return (<span></span>)
  //   }

  // }

  onIconClick(workNo,e) {
    // if (process.env.NODE_ENV === "development") {
    //   alert('show_work_doc:'+workNo)
    // }else{
    //   window.show_work_doc(workNo)
    // }
    this.refs.jsWork.loadData(workNo)
  }

  onPrintClick() {
    let {check,data} = this.state
    let doc_nos = []
    data.forEach(function(item,index) {
      if (check[index]) {
        doc_nos.push(item.doc_no)
      }
    })
    let doc_no = doc_nos.join()
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url  = './?startPage=PrintShippingLabel&idlist='+doc_no+'&doc=quotation'
    } else{
      url = './pdf/v2/?startPage=PrintShippingLabel&idlist='+doc_no+'&doc=quotation'
    }
    this.refs.iframe.loadUrl(url)
  }

  checkAll(check) {
    let {data} = this.state
    let isCheckAll = true
    check.forEach((item,index)=>{
      if (!item&&data[index].work_status!=='3')
        isCheckAll = false
    })
    return isCheckAll
  }

  onRenderColumn(data,col,row,rowIndex){ 
      let {companylist,check} = this.state
      let index = (companylist.length>1)?1:0
      if(col===0){
        return (<Checkbox    
          onChange={this.onCheckChange.bind(this,rowIndex)}      
          checked={check[rowIndex]!==false?true:false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
          disabled={row.work_status==='3'?true:false}
        />)
      } else if(col===11+index){ 
        return this.renderStatus(data,row)
      } else if (col===3) {
        if (data!=="") {
          let title = "ใบงานเลขที่ "+data
          let popoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title={title}>
              <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
            </Popover>
          )

          return (
            <span>
              {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,data)} className="text-blue" name='file-text-o'/></OverlayTrigger>
            </span>
          )
        }  
      } else{ 
        return (<span>{data}</span>)
      }
  }

  onCheckChange(rowIndex){
    let {showSelectMenu,check,isCheckAll} = this.state
    check[rowIndex] = !check[rowIndex]
    showSelectMenu = false
    let key = check.findIndex(x=>x!==false)
    if (key!==-1)
      showSelectMenu = true
    
    isCheckAll = this.checkAll(check)
    this.setState({check:check,showSelectMenu:showSelectMenu,isCheckAll:isCheckAll})
  }

  onCheckAll() {
    let {data,isCheckAll,check} = this.state
    if (data.length===0)
      return false

    if (!isCheckAll) {
      let newCheck = check.map((item,index)=>{
        if (data[index].work_status==='3')
          return false
        else
          return data[index]   
      })
      
      this.setState({isCheckAll:true,check:newCheck,showSelectMenu:true})  
    } else {
      let newCheck = check.map((item,index)=>{
        item = false
        return item
      })
      this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
    }    
  }

  onRenderCheckAll() {
    return(
      <th key={Math.random()} className={'text-center'} style={{width:'50px',maxWidth:'50px'}}>
        <Checkbox
          onChange={this.onCheckAll.bind(this)}
          checked={this.state.isCheckAll}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        >
        </Checkbox>
      </th>
    )
  }

  render(){
    let {showTable,headerTitles,showSelectMenu} = this.state
    
    const searchOptions = [
      {
        label: 'เลขที่ใบเสนอราคา',
        value: 'quotation_no'
      },
      {
        label: 'ใบงานเลขที่',
        value: 'work_no'
      },
      {
        label: 'ทะเบียนรถ',
        value: 'car_registration_no'
      },
      {
        label: 'ลูกค้า/เจ้าของรถ',
        value: 'customer_name'
      },
      {
        label: 'บริษัทประกัน',
        value: 'insurance_name'
      }
    ]
    return (
      <div>
        <div style={{display:showTable?'block':'none'}}>
          <ReportGeneralTable ref='qoTable' 
          title='ใบเสนอราคา' 
          newTitle='เพิ่มรายการ'
          showNewButton={false}
          showSelectMenu={showSelectMenu}
          headerTitles={headerTitles}
          excludeColumn={['status_html','doc_no','doc_status']}
          excludeClickColumn={['work_no']}
          searchOptions={searchOptions}          
          searchBy={'quotation_no'}
          loadData={this.loadData.bind(this)}
          loadDataRange={this.loadDataRange.bind(this)}
          onRenderColumn={this.onRenderColumn.bind(this)}
          onRenderCheckAll={this.onRenderCheckAll.bind(this)}
          onRowSelect={this.onRowSelect.bind(this)} 
          // onDocNew={this.onDocNew.bind(this)}
          showPrintButton={true}
          docType={'quotation'}         
          isMobile={this.props.isMobile}
          mobileFieldMap={{title:'customer_name',amount:'amount',sub_title:'bill_no',date:'doc_date',status:'work_status',sub_status:''}}
          renderWorkStatus={this.renderStatus.bind(this)} 
          printTitle='พิมพ์ใบจ่าหน้าซอง'
          onPrintClick={this.onPrintClick.bind(this)}
          btnTitlePrint='พิมพ์ตาราง'
          />
        </div>
        <div style={{display:!showTable?'block':'none'}}>
          <QuotationDoc
            ref='qoDoc' 
            onClose={this.onDocClose.bind(this)}
          />
        </div>
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        <JSWorkDocViewModal ref="jsWork" title={'แสดงผลใบงาน '} modal={true} fullScreen={true}/>
      </div>
    )
  }
}


export default ReportQuotationPage;





// WEBPACK FOOTER //
// ./src/view/report/ReportQuotationPage.js